import { QRFC } from "./QRFC";

export class QGetAccountInfoRFC extends QRFC {
  constructor() {
    super();
  }

  InitGetAccountInfoRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
  }

  SetParams(org, user) {
    this.AddEncodedParameter("org", org);
    this.AddEncodedParameter("user", user);
  }

  GetCallName() {
    return "qgetaccountinfo";
  }

  DoTransactionComplete(response, callBackObj) {
    response = JSON.parse(response);
    callBackObj.GetAccountInfoResult(response);
  }
}
